import CrossStitchApp from "./CrossStitchApp.jsx";

export default function App() {
  return <CrossStitchApp />;
}
